export const cleanupOrderItemEntries = (entries: string) =>
  entries.replaceAll('\n', ' ').replaceAll(' ', '').split(',');
